import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import Image from '../../../Shared/Image/Image';
import PlayIcon from '../../../../icons/playIcon';
import type {
  ArticleCoverInterface,
  ArticleCoverType,
} from '~/types/AppData/PageContent/ArticleCoverInterface';
import type { ImageWidths } from '~/types/AppData/PartialImageTypes';

interface CardImageInterface {
  cover: ArticleCoverInterface;
  coverType: ArticleCoverType;
  imageWidths: ImageWidths;
  isSingle: boolean;
  imageAspectRatio: string;
  wrapperClass?: string;
  imageClass?: string;
}

export default component$<CardImageInterface>(
  ({
    cover,
    coverType,
    isSingle,
    imageWidths,
    imageAspectRatio,
    wrapperClass,
    imageClass = 'min-w-full object-cover object-center',
  }): JSX.Element => {
    if (!cover.image.value.path) {
      return <></>;
    }

    return (
      <div class={wrapperClass}>
        <Image
          {...cover.image.value}
          aspectRatio={imageAspectRatio}
          imageWidths={imageWidths}
          loading='lazy'
          caption=''
          credit=''
          imageClass={imageClass}
          wrapperClass='min-w-full w-full'
        />
        {coverType === 'video' && (
          <div class='absolute inset-0 flex items-center justify-center'>
            <div class={!isSingle ? 'w-10 h-10' : ''}>
              <PlayIcon svgClass='w-full h-full' />
            </div>
          </div>
        )}
      </div>
    );
  }
);
